<template>
  <article 
    :class="['facial_access', {'facial_access_camera': activeCamera}]" 
    v-if="loaded" >
    <!--Loaders-->
    <transition name="fade">
      <section
        class="facial_access__loaders"
        v-if="!complete_petition && active_request">
        <spin-loader></spin-loader>
        <percentage-loader :percentage="loading_percentage" ></percentage-loader>
      </section>
    </transition>

    <!--Header-->
    <header class="facial_access__header" v-if="!activeCamera">
      <fuseaccess-logo 
        v-if="!access_invitation_approved" 
        class="facial_access__header--logo"></fuseaccess-logo>
      <div 
        v-else 
        style="margin: 0 0.5rem 0 auto; height: 100%;">
        <div style="background: white; border-radius: 0 0 8px 8px;">
          <img 
            style="max-width: 10rem; max-height: 4rem; padding: 0.7rem;" 
            :src="companyLogo">
        </div>
      </div>
    </header>

  
    <!--Content-->
    <section class="facial_access__main_content">

      <transition name="fade">
        <div class="facial_access__content" v-if="expired_invitation">
          <section class="facial_access__success_invitation">
            <time-out-icon class="facial_access__success_invitation--icon"></time-out-icon>
            <div class="facial_access__success_invitation--title">
              <p style="color: black;"><strong>¡Invitación no valida!</strong></p>
            </div>
            <div class="facial_access__success_invitation--text">
              <p style="color: black;">
                Lo sentimos, esta invitación ha <strong>caducado</strong> o ha sido <strong>cancelada</strong> por el anfitrión
              </p>
            </div>
          </section>
        </div>
      </transition>

      <div 
        class="facial_access__calculated_content" 
        v-if=" !expired_invitation && !invitation_already_completed">
        <EmpresarialView 
          @loading="loading" 
          @finish="finish" 
          @camera="cameraActions"
          v-if="loaded && access_invitation_approved"
          ref="modal" :validation="steepsValidator" :basicData="guest_info" :logo="companyLogo" />
        <ResidentialView @loading="loading" @finish="finish"
          ref="modal" v-if="loaded && !access_invitation_approved"
          :validation="steepsValidator"
          :name="invitation.name" :access_types="access_types" :vehicular_type_location="vehicular_type_location" :basicData="guest_info"
          :logo="companyLogo" />
      </div>

      <transition name="fade">
      <div 
        class="facial_access__content" 
        v-if="access_invitation_approved && invitation_already_completed && !expired_invitation">
        <section 
          class="facial_access__success_invitation" 
          style="margin-top: 3rem;">
          <div style="display: flex; width: 100%; justify-content: center;">
            <success-icon class="facial_access__success_invitation--icon"></success-icon>
            <div 
              style="margin-left: 1rem;" 
              class="facial_access__success_invitation--title">
              <p style="color: black;"><strong>¡Registro exitoso!</strong></p>
            </div>
          </div>
          <div style="width: 120px; height: 120px; display: flex; margin: 5rem auto 0 auto;">
            <SittingIcon :color="'#3681ec'"/>
          </div>
          <p style="font-size: 14px; color: black;">En breve recibirás la confirmación en tu Correo y Whatsapp.</p>
          <p style="font-size: 16px; color: black; margin-top: 3rem;">Hasta pronto!</p>
          <div style="margin: 0 auto; height: 60px; width: 180px;">
            <fuseaccess-logo></fuseaccess-logo>
          </div>
        </section>
      </div>
    </transition>

    <transition name="fade">
      <div 
        class="facial_access__content" 
        v-if="invitation_already_completed && !expired_invitation && !access_invitation_approved">
        <section class="facial_access__success_invitation">
          <success-icon class="facial_access__success_invitation--icon"></success-icon>
          <div class="facial_access__success_invitation--title">
            <p style="color: black;"><strong>¡Registro exitoso!</strong></p>
          </div>
          <div class="facial_access__success_invitation--text">
            <p 
              style="color: black;" 
              v-if="invitation.approved">
              <strong>{{ sponsor === null || sponsor === '' ? 'Administración - ' + company_name : sponsor }}</strong> te espera en <br>
              <strong>{{ company_name }}</strong>
            </p>
            <p 
              style="color: black;" 
              v-else>
              Gracias, serás notificado cuando la invitación sea aprobada para que puedas ingresar.
            </p>
          </div>
        </section>
      </div>
    </transition>
    </section>

    <div 
      v-if="steepsValidator.firstStepValid && !invitation_already_completed && !expired_invitation && !activeCamera" 
      style="display: flex; justify-content: center;">
      <footer class="facial_access__footer">
        <div style="display: flex; justify-content: space-between; height: 14px; width: 100%; padding: 0 1rem; margin-bottom: 1.8rem; align-items: center; margin-top: 1rem;">
          <span style="width: 100px; height: 14px;"><fuseaccess-logo></fuseaccess-logo></span>
          <p 
            v-if="steepsValidator.maxSteeps > 1" 
            style="margin-top: 9px; font-size: 10px">paso {{ steepsValidator.step }}/{{ steepsValidator.maxSteeps }}</p>
          <p v-else></p>
        </div>
        <button 
          @click="executeChildAction" 
          :class="['', {'facial_access__button_blue': steepsValidator.step !== steepsValidator.maxSteeps}, {'facial_access__button_green': steepsValidator.maxSteeps === steepsValidator.step}]">{{ steepsValidator.step === steepsValidator.maxSteeps ? 'Finalizar' : 'Continuar' }}</button>
      </footer>
    </div>
  </article>
</template>
<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  import PercentageLoader from '/src/components/shared/icons/PercentageLoader.vue'
  import SelfieIcon from '/src/components/shared/icons/SelfieIcon.vue'
  import TouchIcon from '/src/components/shared/icons/TouchIcon.vue'
  import CloseIcon from '/src/components/shared/icons/CloseIcon.vue'
  import EnvelopeFuseaccess from '/src/components/shared/icons/EnvelopeFuseaccess.vue'
  import SpinLoader from '/src/components/shared/SpinLoader.vue'
  import FuseaccessLogo from '/src/components/shared/icons/FuseaccessLogo.vue'
  import SuccessIcon from '/src/components/shared/icons/SuccessIcon.vue'
  import TimeOutIcon from '/src/components/shared/icons/TimeOutIcon.vue'
  import WarningIcon from '/src/components/shared/icons/WarningIcon.vue'
  import CameraIcon from "@/components/shared/icons/CameraIcon.vue";
  import CameraCapture from "@/components/shared/CameraCapture.vue";
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import EmpresarialView from '../../shared/facial_invitations/EmpresarialView.vue';
  import ResidentialView from '../../shared/facial_invitations/ResidentialView.vue';
  import SittingIcon from '../../shared/icons/SittingIcon.vue';

  export default {
    components:{
      CameraIcon,
      Loading,
      SelfieIcon,
      TouchIcon,
      EnvelopeFuseaccess,
      CloseIcon,
      PercentageLoader,
      SpinLoader,
      FuseaccessLogo,
      SuccessIcon,
      TimeOutIcon,
      WarningIcon,
      CameraCapture,
      EmpresarialView,
      ResidentialView,
      SittingIcon,
    },
    data(){
      return {
        activeCamera:false,
        steepsValidator: {
          isOnFinalStep:  false,
          firstStepValid: false,
          maxSteeps: 0,
          step: 1,
        },
        access_invitation_approved: false,
        active_request: false,
        complete_petition: false,
        complete_charge: false,
        show_selfie_section: false,
        expired_invitation: false,
        code: null,
        invitation_already_completed: false,
        guest_info: {
          name: '',
          email: '',
          location_id: '',
          sublocation_id: '',
          facial_invitation: true,
          invited_client_id:'',
        },
        guest_url_image: null,
        params_user_id: null,
        params_time_send: null,
        params_device_id: null,
        params_begin_server: null,
        params_end_server: null,
        params_user_id_encrypt: null,
        params_invited_client_id: null,
        params_location_name: null,
        params_generated_by_bot: false,
        sponsor: null,
        company_name: null,
        address: null,
        privacy_policy_link: null,
        // expired_previous_entry: false,
        invitation: [],
        company: [],
        location_name: '',
        loaded: false,
        // booking_office: '',
        location_type:'',
        isLoading: false,
        loading_percentage: 0,
        error_plate: false,
        invitation_used: false,
        access_types: [],
        show_form_section: false,
        error_in_petition: false,
        repeat_plate_error: false,
        customized_invitation: false,
        formatted_invitations_dates: [],
        vehicular_type_location: false,
        company_invitation_form_vehicle_data: false,
        companyLogo: null,
      }
    },
    mounted() {
      try{
        let vm = this;
        let params = this.$router.app._route.query;
        if (JSON.stringify(params)!=='{}' && params.device_id !== '' && params.invited_client_id !== '') {
          this.params_device_id = params.device_id
          this.params_user_id_encrypt = params.user_id_encrypt
          this.params_invited_client_id = params.invited_client_id
          this.params_generated_by_bot = params.gbot != null && params.gbot !== undefined && params.gbot == 1 ? true : false
          this.getInvitation()

          setTimeout(() => this.isLoading = false, 1000)
          // this.validatePreviousEntry()
        }
        document.title = 'Invitación de Acceso';
      }catch(e){
        console.error('There are no params ', e);
      }
    },
    destroy(){
      clearInterval(vm.generate_qr)
    },

    methods: {
      cameraActions(event){
        this.activeCamera=event;

      },
      invitationHasExpired(){
        return new Date(this.params_end_server * 1000) < new Date() || this.invitation.invitation_state == 'CANCELLED' || this.invitation.invitation_state == 'COMPLETED'
      },
      invitationWasCompleted(){
        return this.invitation.invitation_state === 'USED' || this.invitation_used === true
      },
      // validatePreviousEntry(){
      //   try {
      //     this.$http.post('app/bookings/invited_client_last_access', { invited_client_id: this.params_invited_client_id},)
      //     .then(function(response){
      //         this.expired_previous_entry = response.body;
      //         console.log('this.expired_previous_entry', this.expired_previous_entry)
      //     }, function(response){
      //         console.log(response.body.data)
      //     })
      //   } catch (e) {
      //     console.log(e.message)
      //   }
      // },
      openCamera() {
      this.showCamera = true;
      },
      handleFileDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file) {
        this.uploadGuestImage({ target: { files: [file] } }, 'guest');
      }
      },
      
      getInvitation(){
        this.isLoading = true
        try {
          this.$http.get('get_invited_clients_by_id?invited_client_id='+this.params_invited_client_id)
          .then(function(response){
            this.access_invitation_approved = response.body.access_invitation_approved
            this.guest_info.name = response.body.invitation.name;
            this.guest_info.email = response.body.invitation.email
            this.guest_info.location_id = response.body.invitation.location_id
            this.guest_info.invited_client_id = this.params_invited_client_id
            this.invitation = response.body.invitation;
            this.location_name = response.body.location;
            this.guest_info.sublocation_id = response.body.sublocation
            this.params_begin_server = Math.floor(new Date(this.invitation.start_time).getTime()/1000)
            this.params_end_server = Math.floor(new Date(this.invitation.end_time).getTime()/1000)
            this.company = response.body.company;
            this.location_name = response.body.location;
            this.params_user_id = this.invitation.user_id;
            this.location_type = response.body.location_type
            this.sponsor = response.body.sponsor
            this.company_name = response.body.company_name
            this.address = response.body.address
            this.privacy_policy_link = response.body.privacy_policy_link
            this.invitation_used = response.body.invitation_used
            this.access_types = response.body.access_types
            this.expired_invitation = this.invitationHasExpired()
            this.invitation_already_completed = this.invitationWasCompleted()
            this.customized_invitation = response.body.customized_invitation
            this.formatted_invitations_dates = response.body.formatted_invitations_dates
            this.loaded = true
            this.vehicular_type_location = response.body.vehicular_type_location
            this.company_invitation_form_vehicle_data = response.body.form_vehicle_data;
            this.companyLogo = response.body.company.url;

            console.log('logo', this.companyLogo)



            // this.booking_office = response.body.booking_office;
            // console.log('booking_office', response.body.booking_office)

          }, function(response){
            console.log(response.body.data)
          })
        } catch (e) {
          console.log(e.message)
        }
        this.invitation_already_completed = true;
      },
      loadPercentage(number){
        for (let i = 0; i < number; i++) {
          this.sumPercentage()
        }
      },
      sumPercentage(){
        if(this.loading_percentage < 100){
          this.loading_percentage += 10
        }
      },
      redirectToQR(){
        let params = this.$router.app._route.query
        if(params.hasOwnProperty("enable_indexes")) window.open(`https://invitation.fusepong.com/#/?enable_indexes&user_id_encrypt=${this.params_user_id_encrypt}&invited_client_id=${this.params_invited_client_id}`, '_blank')
        else window.open(`https://invitation.fusepong.com/#/?device_id=${this.params_device_id}&user_id_encrypt=${this.params_user_id_encrypt}&invited_client_id=${this.params_invited_client_id}`, '_blank')
      },
      executeChildAction() {
        this.$refs.modal.nextStep();
      },
      loading({value, init, finish}) {
        if (finish) {
          this.loading_percentage = 0;
          this.active_request = false;
          this.complete_petition = true;
          return;
        }
        if (init) {
          this.loading_percentage = 0;
          this.active_request = true;
          this.complete_petition = false;
        }
        this.loadPercentage(value);
        
      },
      async finish() {
        this.invitation_already_completed = true;
        this.getInvitation();
      }
    }
  }
</script>